import React from 'react'

import type { HolidayRichTextSection } from '@/src/types/holidays'

import HolidayParagraphs from './holidayParagraphs'

interface HolidayParagraphsWrapperProps {
    section: HolidayRichTextSection
    isMobile: boolean
}

const HolidayParagraphsWrapper: React.FC<HolidayParagraphsWrapperProps> = ({ section, isMobile }) => {
    const paragraphs = (section.paragraphs ?? []).filter(Boolean)
    if (!paragraphs.length) return null

    return <HolidayParagraphs paragraphs={paragraphs} isMobile={isMobile} />
}

export { HolidayParagraphsWrapper }
export default HolidayParagraphsWrapper
